import * as firebase from "firebase/app";
import auth from "firebase/auth";
import firestore from "firebase/firestore";
import storage from "firebase/storage";

var devConfig = {
  apiKey: "AIzaSyCOkOxMvVcZqqL2xw57ztI5YKl9T1rkP98",
  authDomain: "tlz-app-dev.firebaseapp.com",
  databaseURL: "https://tlz-app-dev.firebaseio.com",
  projectId: "tlz-app-dev",
  storageBucket: "tlz-app-dev.appspot.com",
  messagingSenderId: "526085255554",
  appId: "1:526085255554:web:54fa822356a514bb"
};

var prodConfig = {
  apiKey: "AIzaSyDYCQnt80x_IaZ1No6UiZgviGT5TgE_HtE",
  authDomain: "tlz-app.firebaseapp.com",
  databaseURL: "https://tlz-app.firebaseio.com",
  projectId: "tlz-app",
  storageBucket: "tlz-app.appspot.com",
  messagingSenderId: "591988001176",
  appId: "1:591988001176:web:a265126a203692ad"
};

//const config = process.env.NODE_ENV === "production" ? prodConfig : devConfig;

// if (!firebase.apps.length) {
//   firebase.initializeApp(devConfig);
// }

if (!firebase.apps.length) {
  firebase.initializeApp(prodConfig);
}

export default firebase;
